import { arrayBufferToUtf8String, stringToUtf8ArrayBuffer } from "../../utlities/conversions";
export var TextCoding;
(function (TextCoding) {
    TextCoding.Plain = {
        encoder: (data, rsocket) => stringToUtf8ArrayBuffer(data),
        decoder: (buffer, rsocket) => arrayBufferToUtf8String(buffer)
    };
})(TextCoding || (TextCoding = {}));
;
